import { Modal, Form, DatePicker } from "antd";
import { useEffect, useRef, useState } from "react";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useNavigate } from "react-router-dom";
import { formStyle2, layout } from "../styles";
import { useConfirmarPagamentoMC } from "../hooks/useConfirmarPagamentoMC";

interface ModalConfirmarProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  reservaId: null | number;
}

export default function ModalRecebimentoMC({
  isModalOpen,
  handleFechar,
  reservaId,
}: ModalConfirmarProps) {
  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  const [dataRecebimentoMc, setDataRecebimentoMc] = useState("");

  const confirmacaoOnChange = (changedValues: Partial<any>, allValues: any) => {
    setDataRecebimentoMc(allValues);
  };

  const { atualizar, errorMessage, successMessage, isLoading } =
    useConfirmarPagamentoMC(reservaId, dataRecebimentoMc);

  const errorRef = useRef<string | null>(null);

  useEffect(() => {
    if (errorMessage) {
      errorRef.current = errorMessage;
    }
  }, [errorMessage]);
  // Funçao navigate que é utilizada para o reload da página
  const navigate = useNavigate();
  useEffect(() => {
    if (successMessage && !successDisplayed) {
      showSuccess(successMessage);
      setSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Simula um refresh completo
      }, 3000);
    }

    if (errorRef.current && !errorDisplayed) {
      showError(errorRef.current);
      setErrorDisplayed(true);

      setTimeout(() => {
        errorRef.current = null;
        setErrorDisplayed(false);
      }, 2000);
    }
  }, [
    errorMessage,
    showError,
    errorDisplayed,
    successMessage,
    showSuccess,
    successDisplayed,
    navigate,
  ]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Confirmar Data Recebimento MC"
      cancelText="Cancelar"
      okText="Confirmar"
      confirmLoading={isLoading}
      okButtonProps={{
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        },
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        },
      }}
      onOk={() => {
        atualizar();
      }}
    >
      <>
        <>{errorContextHolder}</>
        <>{successContextHolder}</>

        <Form
          {...layout}
          onValuesChange={(changedValues, allValues) =>
            confirmacaoOnChange(changedValues, allValues)
          }
          name="reserva-recebimento-mc"
          style={formStyle2}
        >
          <Form.Item
            name={["dataRecebimentoMC"]}
            label="Data Recebimento MC "
            className="formItems"
          >
            <DatePicker format="DD/MM/YYYY" />
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
}
